import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import PDFToOCRUploadView from "./PDFToOCRUploadView";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";

function PDFOCRMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF OCR - Make PDF Searchable, Selectable Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_ocr", title: "Make PDF searcheable" },
    data2: { link: "/pdf_ocr", title: "OCR PDF For Free" },
    data3: { link: "/pdf_ocr", title: "PDF OCR Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert scanned PDFs to editable text online. Extract text with high accuracy using our fast, secure, and powerful PDF OCR tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf ocr, ocr pdf, convert scanned pdf to text, pdf text recognition, online pdf ocr, extract text from pdf, pdf ocr online, scanned pdf ocr, pdf to text ocr, optical character recognition pdf, pdf ocr tool, editable pdf ocr, image to text pdf, pdf text extractor, document ocr, pdf to ocr searchable pdf, convert pdf to searchable pdf online, convert to searchable pdf, convert to selectable pdf online, pdf image to text pdf online,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {showEditFileScreen ? (
          <PDFToOCRUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            maxPageCount={15}
            allowedFileExtensions={["pdf"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF OCR website provides a powerful and secure solution for converting scanned PDFs and images into editable and searchable text without requiring an internet connection. Designed to work fully offline, this advanced PDF OCR tool processes all files directly on your device, ensuring maximum privacy and data protection. Whether you need to extract text from scanned documents, convert image based PDFs into editable files, or make PDFs searchable, this offline PDF OCR solution delivers accurate and reliable results. The platform supports OCR for PDFs created from scanners, cameras, and image files such as JPG and PNG, preserving layout, fonts, and formatting wherever possible. Users can also access online features when needed, making it a flexible PDF OCR online alternative with offline reliability. Ideal for businesses, students, researchers, and professionals, this tool improves productivity by enabling text search, copy, and edit functions in scanned PDFs. Optimized for speed and accuracy, the website serves as a dependable PDF OCR converter, scan PDF to text tool, and OCR PDF free solution for anyone looking to digitize documents securely. If you are searching for a privacy focused PDF OCR website, an efficient offline OCR tool, or a reliable PDF OCR converter, this platform offers a complete solution for modern document processing needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF OCR Tool"
          why_use={[
            {
              title: "Convert Scanned PDFs into Editable Text",
              description:
                "PDF OCR allows you to convert scanned PDFs and image based documents into editable and selectable text. Using an OCR PDF converter helps reuse content without manual retyping.",
            },
            {
              title: "Make PDFs Searchable",
              description:
                "With PDF OCR software, scanned documents become searchable, allowing users to quickly find keywords and text inside large PDF files.",
            },
            {
              title: "Offline OCR for Data Privacy",
              description:
                "An offline PDF OCR tool processes files directly on your device, keeping sensitive information secure without uploading data to a PDF OCR online service.",
            },
            {
              title: "Save Time and Reduce Manual Effort",
              description:
                "Our PDF OCR converter automates text extraction from scanned documents, helping students, professionals, and businesses save time and effort.",
            },
            {
              title: "Supports Multiple File Formats",
              description:
                "Modern OCR PDF tools support scanned PDFs, JPG, PNG, and other image formats, making OCR PDF free solutions versatile and efficient.",
            },
            {
              title: "Improves Document Accessibility",
              description:
                "PDF OCR enhances accessibility by enabling text selection and screen reader support for scanned PDF documents.",
            },
            {
              title: "Preserves Original Layout",
              description:
                "High quality PDF OCR software maintains original formatting, layouts, and fonts to deliver professional and readable output.",
            },
            {
              title: "Useful for Business and Education",
              description:
                "Businesses use PDF OCR tools to digitize contracts and invoices, while students rely on OCR PDF converters for books, notes, and research documents.",
            },
            {
              title: "Reduces Paper and Storage Needs",
              description:
                "By converting scanned files into searchable PDFs, PDF OCR supports digital documentation and reduces paper usage and physical storage.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFOCRMain;
